import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import * as OrderStatusModels from '../../models/order/orderStatus';
import * as OrderTypeModels from '../../models/order/orderType';
import * as OrderModels from '../../models/order/order';
import * as OrderNoteModels from '../../models/order/order-note';
import * as Models from '../../models/commonModels';

import { OrderSearchModel } from '../../models/order/orderSearch';
import { EnvironmentService } from '../../../app/services/environment.service';


@Injectable({
  providedIn: 'root'
})

export class OrderService {

  constructor(private httpClient: HttpClient,
    private environmentService: EnvironmentService) { }

  public getOrderStatusDictionary(OrderTypeId: number) {

    if (OrderTypeId) { return this.httpClient.get<OrderStatusModels.OrderStatusListModel>(`${this.environmentService.getApiURL()}/order/status/${OrderTypeId}`); }
    else {
      return this.httpClient.get<OrderStatusModels.OrderStatusListModel>(`${this.environmentService.getApiURL()}/order/status`);
    }

  }

  public getOrderTypeDictionary() {
    return this.httpClient.get<OrderTypeModels.OrderTypeListModel>(`${this.environmentService.getApiURL()}/order/types`);
  }

  public get(Search: OrderSearchModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    Search.RequestSignature = Math.random();

    const options = { headers: httpHeaders };

    return this.httpClient.post<OrderModels.OrderListModel>(`${this.environmentService.getApiURL()}/order/list`, Search, options);
  }

  public set(Order: OrderModels.OrderModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<OrderModels.OrderModel>(`${this.environmentService.getApiURL()}/order/set`, Order, options);

  }

  public insert(Order: OrderModels.OrderModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<OrderModels.OrderModel>(`${this.environmentService.getApiURL()}/order/insert`, Order, options);

  }

  public getOrder(OrderId: number) {
    return this.httpClient.get<OrderModels.OrderObjectModel>(`${this.environmentService.getApiURL()}/order/order/${OrderId}`);
  }

  public getReportFiltered(Search: OrderSearchModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json' };

    return this.httpClient.post<Blob>(`${this.environmentService.getApiURL()}/order/report-filtered`, Search, options);
  }

  public getReportNFM(Search: OrderSearchModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json' };

    return this.httpClient.post<Blob>(`${this.environmentService.getApiURL()}/order/report-nfm`, Search, options);
  }

  public setOrderNote(OrderNote: Models.Request<OrderNoteModels.OrderNoteModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<OrderNoteModels.OrderNoteModel>>(`${this.environmentService.getApiURL()}/order/set-order-note`, OrderNote, options);
  }

  public getOrderNotes(Order: Models.RequestModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<OrderNoteModels.OrderNoteModel>>(`${this.environmentService.getApiURL()}/order/order-notes`, Order, options);
  }
}
